mutation UpdateEvent($eventId: ID!, $eventChanges: EventChangeInput!) {
  updateEvent(input: { eventId: $eventId, eventChanges: $eventChanges }) {
    event {
      id
    }
  }
}
